import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/league-spartan";
import "@fontsource-variable/open-sans";
import App from "./App";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode><App /></React.StrictMode>
);
